import { ShrimpHealthColor, ShrimpHealthTarget } from 'modules/notifications/api/types'

export const DISEASE_GROUPS = ['บ่อกรอง', 'บ่อพักใหญ่', 'น้ำทะเล'] as const

// Display order of Lab-table groups, top to bottom (NK-198):
//   1) น้ำทะเล      — seawater intake (น้ำหน้าทะเล)
//   2) บ่อกรอง      — pond before filtering (บ่อก่อนกรอง)
//   3) บ่อพักใหญ่   — holding pond, after filtering (บ่อพัก หลังกรองน้ำ)
// The API returns rows in a different group order; the selector stable-sorts by
// this rank so within-group rows (liver/stomach/water + age) stay intact.
export const DISEASE_GROUP_ORDER: Record<string, number> = {
  น้ำทะเล: 0,
  บ่อกรอง: 1,
  บ่อพักใหญ่: 2,
}

export const SUB_GROUPS = {
  LIVER: 'ตับ',
  STOMACH: 'กระเพาะ',
  WATER: 'น้ำ',
} as const

export const LABELS = {
  YELLOW: 'เหลือง',
  GREEN: 'เขียว',
  BLACK: 'ดำ',
  GREEN_YELLOW: 'g/y',
  AGE: 'อายุกุ้ง',
} as const

export const FIELD_MAPPING = {
  ตับ: {
    เหลือง: 'liver_yellow',
    เขียว: 'liver_green',
    ดำ: 'liver_black',
    'g/y': 'liver_green_yellow',
  },
  กระเพาะ: {
    เหลือง: 'stomach_yellow',
    เขียว: 'stomach_green',
    ดำ: 'stomach_black',
    'g/y': 'stomach_green_yellow',
  },
  น้ำ: {
    เหลือง: 'yellow_vibrio',
    เขียว: 'green_vibrio',
    ดำ: 'black_vibrio',
    'g/y': 'green_yellow_vibrio',
  },
} as const

export const DISEASE_GROUP_TRANSLATION: Record<string, string> = {
  บ่อกรอง: 'lab.table.filterPond',
  บ่อพักใหญ่: 'lab.table.largeManhole',
  น้ำทะเล: 'lab.table.seaWater',
}

export const SUB_GROUP_TRANSLATION: Record<string, string> = {
  ตับ: 'lab.table.liver',
  กระเพาะ: 'lab.table.stomach',
  น้ำ: 'lab.table.water',
}

export const LABEL_TRANSLATION: Record<string, string> = {
  เหลือง: 'lab.table.yellow',
  เขียว: 'lab.table.green',
  ดำ: 'lab.table.black',
  'g/y': 'lab.table.g_y',
  อายุกุ้ง: 'lab.table.shrimpAge',
}

export const TRANSLATION_KEYS = {
  HEADER: {
    POND: 'lab.table.pond',
    SECTION: 'lab.table.section',
    BACTERIA: 'lab.table.strain',
  },
  MESSAGES: {
    NO_DATA: 'noData',
    LOAD_MORE: 'loadMore',
    RELEASE_TO_LOAD: 'lab.table.releaseToLoad',
  },
} as const

// NK-273: lab-table sub group / label → the shrimp-health alert setting keys.
export const SHRIMP_HEALTH_TARGET_BY_SUB_GROUP: Record<string, ShrimpHealthTarget> = {
  [SUB_GROUPS.LIVER]: 'liver',
  [SUB_GROUPS.STOMACH]: 'stomach',
  [SUB_GROUPS.WATER]: 'water',
}

export const SHRIMP_HEALTH_COLOR_BY_LABEL: Record<string, ShrimpHealthColor> = {
  [LABELS.YELLOW]: 'yellow',
  [LABELS.GREEN]: 'green',
  [LABELS.BLACK]: 'black',
  [LABELS.GREEN_YELLOW]: 'green_yellow',
}

export const THRESHOLD_VALUES = {
  YELLOW_THRESHOLD: 200,
  DEFAULT_THRESHOLD: 0,
} as const

export const DISPLAY_VALUES = {
  EMPTY: '-',
  NO_SUBGROUP: 'no-subgroup',
} as const

export const getTranslationKey = (value: string, type: 'group' | 'subGroup' | 'label'): string => {
  switch (type) {
    case 'group':
      return DISEASE_GROUP_TRANSLATION[value] || value
    case 'subGroup':
      return SUB_GROUP_TRANSLATION[value] || value
    case 'label':
      return LABEL_TRANSLATION[value] || value
    default:
      return value
  }
}
